export default __webpack_public_path__ + "static/media/delete-outline.f4474fae.svg";